export const PERMISSIONS = {
    CAN_EDIT: 'CAN_EDIT',
    CAN_START_STOP: 'CAN_START_STOP',
    CAN_UPDATE_TAGS: 'CAN_UPDATE_TAGS',
    CAN_ACCESS_ALL: 'CAN_ACCESS_ALL',
    CAN_MANAGE_USERS_ROLES: 'CAN_MANAGE_USERS_ROLES',
    IS_SUPER_ADMIN: 'IS_SUPER_ADMIN'
};



export const hasAction = (actionName) => {
    try {
        const storedActions = sessionStorage.getItem('userActions');

        if (!storedActions) return false;

        const actions = JSON.parse(storedActions);

        return actions[actionName] === true;
    } catch (error) {
        console.error('Error reading actions', error);
        return false;
    }
};

export const hasPermission = (requiredPermission) => {
    try {
        const storedPerms = sessionStorage.getItem('userPermissions');
        if (!storedPerms) return false;

        const userPermissions = JSON.parse(storedPerms);

        if (Array.isArray(requiredPermission)) {
            return requiredPermission.some(perm => userPermissions.includes(perm));
        }

        return userPermissions.includes(requiredPermission);
    } catch (error) {
        console.error("Error reading permissions from sessionStorage", error);
        return false;
    }
};